module.exports = __webpack_public_path__ + "media/beep-01.c00f0bbf.mp3";